// QuestionInterface.js
import React, { useEffect, useRef, useState } from "react";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
//import CommentsSection from "./CommentsSection"; // Adjust the path as necessary
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import MockTestQuestions from "./MockTestQuestions";
import TextField from "@mui/material/TextField"; // Import TextField
import "react-simple-keyboard/build/css/index.css";
import Keyboard from "react-simple-keyboard";
import CalculateIcon from "@mui/icons-material/Calculate";

import CountdownTimer from "./CountdownTimer";
//import { setSubcategories } from '../../../../../redux/slices/subcategoriesListSlice';

import {
  MoveNextQuestion,
  MovePrevQuestion,
} from "../../../../../hooks/FetchQuestion";
import { setTraceAction } from "../../../../../redux/reducers/question_reducer";

import "./MockTestQuestionInterface.css"; //css

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import FlagIcon from "@mui/icons-material/Flag";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

/** redux store import */
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import MockTestReviewCard from "./MockTestReviewCard";
import {
  flagQuestion,
  insertForMockReview,
  unflagQuestion,
  reportQuestionInsert,
  submitMockQuestionData,
  submitMockQuestionResults,
  submitLongFormatQuestionInMockForReview,
  saveMockSession,
  getMockSession,
  deleteMockSession,
} from "../../../../../api/auth";

const MockTestQuestionInterface = () => {
  const theme = useTheme();
  const calculatorFullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [flags, setFlags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const userId = useSelector((state) => state.auth.userId);
  const [isFlagged, setIsFlagged] = useState(false);
  const [reviewCardOpen, setReviewCardOpen] = useState(false);
  //const [openDialog, setOpenDialog] = useState(false); // Existing dialog for finish button
  const [openReportDialog, setOpenReportDialog] = useState(false); // Ne
  const [reportText, setReportText] = useState(""); // State to store the report text
  const date = new Date();
  const university = useSelector((state) => state.auth.universityName);
    const course = useSelector((state) => state.auth.courseName);
    const mock_name = useSelector((state) => state.questions.mock_name);
  const [subcategories, setSubcategories] = useState();
  // Calculator State
  const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);
  const [calculatorInput, setCalculatorInput] = useState("");

  const { queue, trace } = useSelector((state) => state.questions);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const questionType = useSelector(
    (state) => state.questions.queue[state.questions.trace]?.type || null
  );

  const selectCurrentSubcategory = useSelector(
    (state) => state.questions.currentSubcategory
  );

  const handleQuestionClick = (questionNumber) => {
    dispatch(setTraceAction(questionNumber - 1)); // dispatch action to update the trace value
  };

  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenReportDialog = () => setOpenReportDialog(true);
  const handleCloseReportDialog = () => setOpenReportDialog(false);
  const handleReportTextChange = (event) => setReportText(event.target.value);

  const subcats = useSelector((state) => state.subcategoriesList.subcategories);
  const status = useSelector((state) => state.subcategoriesList.status); // Get the status from Redux state
  const [subcategoryScores, setSubcategoryScores] = useState({});
  const [mockAnswers, setMockAnswers] = useState({});
  const mockAnswersRef = useRef({});
  const [sessionRestored, setSessionRestored] = useState(false);

  useEffect(() => {
    mockAnswersRef.current = mockAnswers;
  }, [mockAnswers]);


  // Function to toggle calculator
  const toggleCalculator = () => {
    setIsCalculatorOpen(!isCalculatorOpen);
  };

  // Function to update calculator input
  const handleCalculatorChange = (input) => {
    setCalculatorInput(input);
  };

  // Function to evaluate the calculator expression
  const evaluateExpression = () => {
    try {
      setCalculatorInput(eval(calculatorInput).toString()); // Simple eval-based calculator
    } catch (error) {
      setCalculatorInput("Error");
    }
  };

  const handleKeyPress = (button) => {
    if (button === "=") {
      try {
        setCalculatorInput(eval(calculatorInput).toString()); // Evaluate the expression
      } catch (error) {
        setCalculatorInput("Error");
      }
    } else if (button === "C") {
      setCalculatorInput(""); // Clear input
    } else {
      setCalculatorInput((prev) => prev + button); // Append input
    }
  };

  useEffect(() => {
    if (!userId || !mock_name || !queue?.length || sessionRestored) return;

    (async () => {
      try {
        const data = await getMockSession(userId, mock_name);
        if (data?.session) {
          const saved =
            typeof data.session.answers === "string"
              ? JSON.parse(data.session.answers)
              : data.session.answers || {};
          setMockAnswers(saved);
          const savedFlags =
            typeof data.session.flags === "string"
              ? JSON.parse(data.session.flags)
              : data.session.flags;
          if (Array.isArray(savedFlags) && savedFlags.length === queue.length) {
            setFlags(savedFlags);
          } else {
            setFlags(Array(queue.length).fill(false));
          }
          if (
            typeof data.session.current_index === "number" &&
            data.session.current_index < queue.length
          ) {
            dispatch(setTraceAction(data.session.current_index));
          }
        } else {
          setFlags(Array(queue.length).fill(false));
        }
      } catch (error) {
        console.error("Failed to restore mock session:", error);
        setFlags(Array(queue.length).fill(false));
      } finally {
        setSessionRestored(true);
      }
    })();
  }, [userId, mock_name, queue, sessionRestored, dispatch]);

    useEffect(() => {
        console.log("Current Subcategory:", selectCurrentSubcategory);
    }, [selectCurrentSubcategory,]);

  useEffect(() => {
    // Check if the status is 'succeeded' and subcategories are available
    if (status === "succeeded" && subcats) {
      // Initialize subcategory scores with correctScore and incorrectScore
      const initialScores = {};
      Object.keys(subcats).forEach((subcategory) => {
        initialScores[subcategory] = {
          correctScore: 0, // Start correctScore at 0
          incorrectScore: 0, // Start incorrectScore at 0
        };
      });

      // Update the state with the initial scores
      setSubcategoryScores(initialScores);

      // Log the initialized scores
      console.log("Subcategory scores initialized:", initialScores);
    } else if (status === "loading") {
      console.log("Loading subcategories...");
    } else if (status === "failed") {
      console.log("Failed to load subcategories");
    }
  }, [subcats, status]); // Depend on subcats and status

  const flaggedQuestions = flags.reduce((acc, flagged, index) => {
    if (flagged) acc.push(index + 1);
    return acc;
  }, []);

  const handleFinishClick = () => {
    console.log("Finish clicked, flagged questions:", flaggedQuestions);
    if (flaggedQuestions.length >= 0) {
      setOpenDialog(true); // Open dialog if there are flagged questions
    } else {
      handleResults(); // Otherwise proceed to results
    }
  };

  const handleSubmitReport = () => {
    reportQuestionInsert(
      questionID, //questionId,
      reportText, //problem,
      university,
      course,
      // category,
      // subcategory,
      date
    );
    console.log("Report submitted:", reportText);
    // Placeholder for actual report submission logic
    setReportText(""); // Clear text after submission
    handleCloseReportDialog();
  };

  const handleCloseDialog = (shouldFinish) => {
    setOpenDialog(false);
    if (shouldFinish) {
      setIsLoading(true);
      setTimeout(() => {
        handleResults();
        setIsLoading(false);
      }, 2000);
    }
  };

  const questionIds = useSelector((state) => state.questions.queue);
  const sessionarray = questionIds.map((question) => question.id);

  const questionID = useSelector(
    (state) => state.questions.queue?.[trace]?.id || null
  );

  useEffect(() => {
    setIsFlagged(false);
  }, [trace]);

  async function handleFlagClick() {
    let newFlags = [...flags];
    const index = trace; // assuming `trace` is the index of the current question

    try {
      if (newFlags[index]) {
        // Attempt to unflag the question
        const response = await unflagQuestion(userId, queue[index].id);
        if (response.data.success) {
          console.log("Question unflagged successfully", questionType);
          newFlags[index] = false;
        } else {
          console.error("Error unflagging question:", response.data.message);
        }
      } else {
        // Attempt to flag the question
        const response = await flagQuestion(userId, queue[index].id);
        if (response.data.success) {
          console.log("Question flagged successfully", questionType);
          newFlags[index] = true;
        } else {
          console.error("Error flagging question:", response.data.message);
        }
      }
      setFlags(newFlags);
    } catch (error) {
      console.error("Error in flag/unflag operation:", error);
      alert(
        "There was an error processing your flagging request. Please try again later."
      );
    }
  }

  const handleAnswerChange = (questionId, answerData) => {
    setMockAnswers((prev) => ({
      ...prev,
      [questionId]: answerData,
    }));
  };

  const persistMockSession = async (index = trace, answersOverride) => {
    await saveMockSession({
      user_id: userId,
      mock_name,
      question_ids: sessionarray,
      current_index: index,
      answers: answersOverride ?? mockAnswersRef.current,
      flags,
    });
  };

  const handleSaveAndExit = async () => {
    try {
      await persistMockSession();
      navigate("/dashboard/mock", { replace: true });
    } catch (error) {
      console.error("Save and exit failed:", error);
      alert("Could not save your progress. Please try again.");
    }
  };

  async function finalizeMockAnswers() {
    const scores = { ...subcategoryScores };

    for (const question of queue) {
      const answer = mockAnswers[question.id];
      if (!answer) continue;

      const subcat = question.subcategory || selectCurrentSubcategory;

      if (question.type === 1 && answer.option_id) {
        const correct = answer.option_id === getCorrectOptionId(question.id);
        if (scores[subcat]) {
          if (correct) scores[subcat].correctScore += 1;
          else scores[subcat].incorrectScore += 1;
        }
        const userOption = question.options.find(
          (opt) => opt.option_id === answer.option_id
        );
        const correctOption = question.options.find((opt) => opt.is_correct);
        await submitMockQuestionData(
          question.id,
          answer.option_id,
          correct,
          userId,
          mock_name
        );
        await insertForMockReview(
          userId,
          question.id,
          question.question,
          userOption?.option_text,
          correctOption?.option_text,
          correct,
          mock_name
        );
      }

      if (question.type === 2 && answer.text) {
        const correctOption = question.options.find((opt) => opt.is_correct);
        await submitLongFormatQuestionInMockForReview({
          question_id: question.id,
          question_text: question.question,
          question_answer: correctOption?.option_text,
          question_subcategory: subcat,
          user_answer: answer.text,
          user_id: userId,
          max_marks: question.max_marks,
          subquestion_data: [],
          mock_name,
        });
        await insertForMockReview(
          userId,
          question.id,
          question.question,
          answer.text,
          correctOption?.option_text,
          false,
          mock_name
        );
      }

      if (question.type === 3 && answer.parent_text) {
        const correctOption = question.options.find((opt) => opt.is_correct);
        const childParts = Array.isArray(question.child_question_ids)
          ? question.child_question_ids
          : [];
        const subData = Object.entries(answer.child_answers || {}).map(
          ([idx, userAnswer]) => {
            const child = childParts[idx];
            return {
              question_b_text:
                child?.question_b_text ||
                child?.question_c_text ||
                child?.question_d_text,
              user_answer: userAnswer,
              is_correct: child?.correct_answer,
            };
          }
        );
        await submitLongFormatQuestionInMockForReview({
          question_id: question.id,
          question_text: question.question,
          question_answer: correctOption?.option_text,
          question_subcategory: subcat,
          user_answer: answer.parent_text,
          user_id: userId,
          max_marks: question.max_marks,
          subquestion_data: subData,
          mock_name,
        });
        await insertForMockReview(
          userId,
          question.id,
          question.question,
          answer.parent_text,
          correctOption?.option_text,
          false,
          mock_name
        );
      }
    }

    setSubcategoryScores(scores);
    return scores;
  }

  /** next button event handler */
  async function onNext() {
    if (trace < queue.length - 1) {
      const nextIndex = trace + 1;
      dispatch(MoveNextQuestion());
      try {
        await persistMockSession(nextIndex);
      } catch (error) {
        console.error("Failed to save mock progress:", error);
      }
    }
  }

  async function onPrev() {
    if (trace > 0) {
      const prevIndex = trace - 1;
      dispatch(MovePrevQuestion());
      try {
        await persistMockSession(prevIndex);
      } catch (error) {
        console.error("Failed to save mock progress:", error);
      }
    }
  }

  async function handleResults() {
    setIsLoading(true);
    try {
      const scores = await finalizeMockAnswers();
      const subcategoryScoresJSON = JSON.stringify(scores);
      await submitMockQuestionResults(userId, subcategoryScoresJSON, mock_name);
      await deleteMockSession(userId, mock_name);
      navigate("/dashboard/mock-test/questions/results", { replace: true });
    } catch (error) {
      console.error("Error finishing mock:", error);
      alert("Something went wrong finishing the test. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }

  function getCorrectOptionId(questionId) {
    const question = queue.find((q) => q.id === questionId);
    return question?.options.find((opt) => opt.is_correct)?.option_id;
  }

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        minHeight: { xs: "100dvh", sm: "100vh" },
        height: { xs: "auto", sm: "100vh" },
        overflow: "auto",
        p: { xs: 1, sm: 2 },
      }}
    >
      <Container
        height="100%"
        maxWidth="1600px"
        sx={{
          mt: { xs: 2, sm: 4 },
          mb: { xs: 2, sm: 4 },
          height: { xs: "auto", sm: "calc(100vh - 8rem)" },
          minHeight: { xs: "calc(100dvh - 4rem)", sm: undefined },
        }}
      >
        <Paper
          // Adjust the number to increase or decrease shadow depth
          square={false} // If set to true, it removes the border-radiu
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "80vh", // Setting minimum height
            height: "100%",
            position: "relative",
            overflow: "auto",
          }}
        >
          <div className="nav-button-container">
            <div className="inner-container">
              <div className="question-counter">
                Question {trace + 1} of {queue.length}
                {/* Flag IconButton added here */}
                <IconButton
                  className="flag-button"
                  onClick={handleFlagClick}
                  style={{ color: flags[trace] ? "red" : "inherit" }} // change color if flagged for current question
                >
                  <FlagIcon />
                </IconButton>
                <IconButton
                  className="calculator-button"
                  onClick={toggleCalculator}
                  sx={{
                    ml: 0.2,
                    backgroundColor: "#007BFF",
                    color: "white",
                    "&:hover": { backgroundColor: "#0056b3" },
                  }}
                >
                  <CalculateIcon sx={{ fontSize: "1.3rem" }} />{" "}
                  {/* Adjust size */}
                </IconButton>
                {/* Mock exam duration from mockExamCountdownConfig + Redux universityName */}
                <Box
                  component="span"
                  className="timer"
                  sx={{
                    ml: { xs: 0.5, sm: "20px" },
                    fontWeight: "bold",
                    fontSize: { xs: "14px", sm: "16px" },
                    color: "red",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  ⏳ <CountdownTimer />
                </Box>
                {/* Calculator Modal */}
                <Dialog
                  open={isCalculatorOpen}
                  onClose={toggleCalculator}
                  fullScreen={calculatorFullScreen}
                  maxWidth="xs"
                  fullWidth
                >
                  <DialogTitle>Calculator</DialogTitle>
                  <DialogContent>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={calculatorInput}
                      onChange={(e) => setCalculatorInput(e.target.value)}
                      sx={{ mb: 2 }}
                    />
                    <Keyboard
                      onKeyPress={(button) => handleKeyPress(button)} // Use a separate function
                      layout={{
                        default: [
                          "7 8 9 /",
                          "4 5 6 *",
                          "1 2 3 -",
                          "0 . = +",
                          "C",
                        ],
                      }}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={toggleCalculator} color="primary">
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              <Box className="mui-nav-box-root">
                {trace > 0 && (
                  <IconButton onClick={onPrev} aria-label="previous">
                    <ArrowBackIosIcon className="back-icon" />
                  </IconButton>
                )}
                {trace < queue.length - 1 ? (
                  <IconButton onClick={onNext} aria-label="next">
                    <ArrowForwardIosIcon />
                  </IconButton>
                ) : (
                  <button className="btn results" onClick={handleFinishClick}>
                    Finish Test
                  </button>
                )}
              </Box>
            </div>
          </div>
          {/* Add  question content here - will add some sort of standalone component for the question ui */}

          <div className="parent-content-container">
            <div className="content-container">
              <MockTestQuestions
                savedAnswer={mockAnswers[queue[trace]?.id]}
                onAnswerChange={handleAnswerChange}
              />
            </div>

            <div
              className={`review-card-container ${reviewCardOpen ? "review-card-expanded" : "review-card-collapsed"}`}
            >
              <MockTestReviewCard
                trace={trace}
                flags={flags}
                onToggle={(isOpen) => setReviewCardOpen(isOpen)}
                onQuestionClick={handleQuestionClick}
              />
            </div>
          </div>

          <div className="submit-button-container">
            <div className="inner-container submit-actions-inner">
              <Box className="mui-box-root">
                <button
                  className="btn submit"
                  onClick={handleSaveAndExit}
                  disabled={isLoading}
                >
                  Save and Exit
                </button>

                <Dialog
                  open={openReportDialog}
                  onClose={handleCloseReportDialog}
                >
                  <DialogTitle>Report an Issue</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Please describe the issue with this question.
                    </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="report-issue"
                      label="Issue Description"
                      type="text"
                      fullWidth
                      variant="outlined"
                      value={reportText}
                      onChange={handleReportTextChange} // Capture user input
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseReportDialog} color="primary">
                      Cancel
                    </Button>
                    <Button onClick={handleSubmitReport} color="primary">
                      Submit
                    </Button>
                  </DialogActions>
                </Dialog>

               <Dialog open={openDialog} onClose={() => handleCloseDialog(false)}>
                  <DialogTitle>{"Finish Session?"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      {flaggedQuestions.length > 0
                        ? `You have flagged questions: ${flaggedQuestions.join(", ")}. Do you want to review them or finish the session?`
                        : "Are you sure you want to finish and submit? This action cannot be undone."}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => handleCloseDialog(false)}>
                      {flaggedQuestions.length > 0 ? "Review" : "Cancel"}
                    </Button>
                    <Button onClick={() => handleCloseDialog(true)} autoFocus>
                      {flaggedQuestions.length > 0 ? "Finish" : "Confirm Submission"}
                    </Button>
                  </DialogActions>
                </Dialog>
              </Box>
            </div>
          </div>
        </Paper>
      </Container>
    </Box>
  );
};

export default MockTestQuestionInterface;
